import { Component, computed, inject, input } from '@angular/core';
import { Router } from '@angular/router';
import { QrBuildingTab, qrBuildingContext } from '@services/qr-building-context.service';

interface QrTabLink {
  readonly tab: QrBuildingTab;
  readonly label: string;
  readonly icon: string;
  readonly dataCy: string;
}

const BUILDING_TAB: QrTabLink = { tab: '', label: 'Gebäude', icon: 'house', dataCy: 'qr-tab-building' };
const TGA_TAB: QrTabLink = { tab: 'tga', label: 'TGA', icon: 'cubes', dataCy: 'qr-tab-tga' };
const MAINTENANCE_TAB: QrTabLink = { tab: 'maintenance', label: 'Wartung', icon: 'hourglass-half', dataCy: 'qr-tab-maintenance' };
const REPAIR_TASKS_TAB: QrTabLink = {
  tab: 'repairTasks',
  label: 'Aufträge',
  icon: 'screwdriver-wrench',
  dataCy: 'qr-tab-repair-tasks',
};

@Component({
  standalone: false,
  selector: 'wr-qr-code-building-header',
  templateUrl: './qr-code-building-header.component.html',
  styleUrls: ['./qr-code-building-header.component.scss'],
})
export class QrCodeBuildingHeaderComponent {
  private readonly router = inject(Router);

  readonly active = input.required<QrBuildingTab>();
  readonly showSections = input(false);

  readonly context = qrBuildingContext();

  readonly tabs = computed(() => {
    const session = this.context.session();
    return [
      BUILDING_TAB,
      TGA_TAB,
      ...(session?.canViewMaintenanceTimers ? [MAINTENANCE_TAB] : []),
      ...(session?.canViewRepairTasks ? [REPAIR_TASKS_TAB] : []),
    ];
  });

  readonly selectableSections = computed(() => {
    const sections = this.context.buildingInfo()?.buildingSections ?? [];
    return this.showSections() && this.context.isExternal() && sections.length > 1 ? sections : [];
  });

  navigate(tab: QrBuildingTab): void {
    this.router.navigate(this.context.tabPath(tab));
  }

  openAllBuildings(): void {
    this.router.navigate(this.context.allBuildingsPath());
  }
}
